import React from 'react';

import {useSelector} from 'react-redux';

import {getReviewDateStatus} from 'app/review/utils';
import {accountSettingsSelector} from 'app/settings/api';

import type {ReviewDateState} from 'app/review/types';
import type {ComponentType} from 'react';

type Props = {
  reviewDate: string | null;
};

export type ShowOnReviewStateInjectedProps = Props & {
  reviewDateState: ReviewDateState;
};

export function showOnReviewState<T>(
  renderWhenState: Array<ReviewDateState>
): (
  WrappedComponent: ComponentType<T & ShowOnReviewStateInjectedProps>
) => ComponentType<Omit<T, keyof ShowOnReviewStateInjectedProps> & Props> {
  return function (
    WrappedComponent: ComponentType<T & ShowOnReviewStateInjectedProps>
  ): ComponentType<Omit<T, keyof ShowOnReviewStateInjectedProps> & Props> {
    return function ({
      reviewDate,
      ...others
    }: Props & Omit<T, keyof ShowOnReviewStateInjectedProps>) {
      const reviewReminderTime = useSelector(accountSettingsSelector)?.data
        ?.reviews.reminder_time;

      if (reviewDate == null) {
        return null;
      }

      const reviewDateState = getReviewDateStatus(
        reviewDate,
        reviewReminderTime ? reviewReminderTime : ''
      );

      if (renderWhenState.indexOf(reviewDateState) === -1) {
        return null;
      }

      return (
        <WrappedComponent
          {...(others as any as T)}
          reviewDate={reviewDate}
          reviewDateState={reviewDateState}
        />
      );
    };
  };
}
